import { alpha, lighten } from "@mui/material/styles";

// Accent for the Show-page section boxes (shadowBox / shadowBoxMobile in style.*.js), built from the
// tenant's primary colors:
// - left bar: vertical gradient light -> main -> dark (border-image paints only the left border, the only
//   one with width; note border-image ignores border-radius, so the box stays square);
// - shadow: a soft neutral lift plus a primary-tinted glow, stronger on the right like the old accent.
export const shadowBoxAccent = ({ main, dark }, { barWidth = 6 } = {}) => ({
  borderLeft: `${barWidth}px solid`,
  borderImage: `linear-gradient(180deg, ${lighten(main, 0.45)} 0%, ${main} 45%, ${dark} 100%) 1`,
  boxShadow: [
    "0 1px 2px rgba(0, 0, 0, 0.05)",
    `0 6px 20px -6px ${alpha(main, 0.25)}`,
    `10px 0 22px -10px ${alpha(main, 0.45)}`,
  ].join(", "),
});
